import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Home, LineChart, Bitcoin } from 'lucide-react';
export function ThreePillarsSection() {
  const pillars = [{
    icon: <Home className="w-8 h-8 text-gold-400" data-id="element-208" />,
    title: 'Crédito y Real Estate',
    headline: 'Deja de pagar la hipoteca de tu landlord.',
    copy: 'Cada mes que pagas renta, estás construyendo el palacio de otra persona. Con el crédito correcto y el 3.5% de enganche, el dueño puedes ser tú. Usa el sistema FHA a tu favor. Usa el House Hacking.'
  }, {
    icon: <LineChart className="w-8 h-8 text-gold-400" data-id="element-209" />,
    title: 'Bolsa de Valores',
    headline: 'De cobrar el cheque a cobrar los dividendos.',
    copy: '¿Te imaginas recibir una notificación en tu celular que te avisa que las empresas más grandes del mundo acaban de pagarte por ser dueño? Eso es Wall Street para nosotros. Sin tabúes, sin palabras técnicas.'
  }, {
    icon: <Bitcoin className="w-8 h-8 text-gold-400" data-id="element-210" />,
    title: 'Cripto y Activos Digitales',
    headline: 'Mientras tú dudas, el sistema se reinicia.',
    copy: 'Bitcoin no es una moda, es la salida de emergencia de un sistema que imprime billetes sin parar. Aprende a generar rentabilidad pasiva. No necesitas ser un genio de la tecnología, solo el Código correcto.'
  }];
  return <section className="py-24 relative" data-id="element-211">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-212">
        <FadeIn className="text-center mb-16" data-id="element-213">
          <div className="text-gold-400 font-serif tracking-widest text-sm uppercase mb-4" data-id="element-214">
            La Ventaja Injusta
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-215">
            Las tres patas de la mesa de la{' '}
            <span className="text-gradient-gold" data-id="element-216">riqueza.</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-217">
            Juega con las mismas reglas que los millonarios. Ellos no trabajan
            por dinero, hacen que el dinero trabaje por ellos.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-218">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-219">
              <div className="h-full bg-navy-900/50 border border-navy-700 hover:border-gold-500/50 p-8 rounded-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(212,175,55,0.05)] group" data-id="element-220">
                <div className="w-16 h-16 rounded-full bg-navy-950 border border-navy-700 group-hover:border-gold-500/30 flex items-center justify-center mb-6 transition-colors" data-id="element-221">
                  {pillar.icon}
                </div>
                <div className="text-sm text-gold-500/80 font-semibold uppercase tracking-wider mb-3" data-id="element-222">
                  {pillar.title}
                </div>
                <h3 className="text-2xl font-serif font-bold text-white mb-4 leading-snug" data-id="element-223">
                  {pillar.headline}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-224">{pillar.copy}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}